module.exports = __webpack_public_path__ + "static/img/home_ddky_2.ba4a3e0b.png";